import React from 'react';
import Masonry from 'react-masonry-component';
import styled from 'styled-components';
import { Helmet } from "react-helmet";
import MainVisual from '../components/MainVisual';
import Break from '../components/Break';
import MainContainerL from '../components/MainContainerL';
import MainContainerM from '../components/MainContainerM';
import MainContainerS from '../components/MainContainerS';
import MainContainerYT from '../components/MainContainerYT';
import Billing from '../components/Billing';
import TopButton from '../components/TopButton';

import SpBgImg from '../assets/images/top/main-sp05.jpg';
import MainCopy01 from '../assets/images/top/main-copy01.png';
import MainCopy02 from '../assets/images/top/main-copy02.png';

class Home extends React.Component {
  getPost() {
    let data = [];
    fetch('https://complicity.movie/api')
        .then((response) => {
          let json = response.json();
          json.then((json) => {
            data = json.map((d) => {
              const comment = {};
              comment['ID'] = d.ID;
              comment['post_date'] = d.post_date;
              const meta_keys = d.meta_keys.split('||');
              const meta_values = d.meta_values.split('||');
              const img_ids = d.img_meta_keys.split('||');
              const img_values = d.img_meta_values.split('||');
              meta_keys.forEach((key,idx) => {
                if(key === "order"){
                  if(meta_values[idx] !== undefined){
                    comment[key] = meta_values[idx].split(',').map(Number);
                  }else{
                    comment[key] = [];
                  }
                }else{
                  comment[key] = meta_values[idx];
                }
              });
              img_ids.forEach((id,idx) => {
                comment[id] = img_values[idx];
              });
              return comment;
            })
          })
      }, (error) => {
        console.error(error);
      }).then(() => {
        setTimeout(() => {
          const firstList = data.filter(d => d.order[0] !== "" && d.order[0] === 1)
            .map(d => <Container postDate={d.post_date} data={d} key={d.ID} />);
          let maxBlock = 2;
          data.forEach((c) => {
            if(maxBlock < c.order[0]){
              maxBlock = c.order[0];
            }
          });

          const listContainer = [];
          for(let i = 2; i <= maxBlock; i++){
            const list = data.filter(d => d.order[0] !== "" && d.order[0] === i)
              .sort((a, b) => {
                if(a.order[1] > b.order[1]){
                  return 1;
                }else{
                  return -1;
                }
              })
              .map(d => <Container postDate={d.post_date} data={d} key={d.ID} />);

            const options = {
              columnWidth: '.grid-sizer',
              itemSelector: '.grid-item',
              percentPosition: true
            }
            const Block = <div key={i}>
                            {list[0]}
                            <Masonry className="main-container__inner" options={options} enableResizableChildren>
                              <div className="grid-sizer"></div>
                              {list.splice(1, list.length)}
                            </Masonry>
                          </div>;

            listContainer.push(Block);
          }
          this.setState({
            data: data,
            firstList: firstList,
            listContainer: listContainer,
            isLoad: true
          });
        }, 3000);
      });
  }



    constructor(props){
        super(props);
        this.getPost();
        this.state = {
          view: false,
          data: [],
          firstList: [],
          listContainer: []
        }
    }
    componentDidMount() {
      window.addEventListener('scroll', event => this.fadeinIntoView(), true);

      const copyImg = document.querySelectorAll('.loading-copy img');
      const copyBack = document.querySelectorAll('.loading');
      const main = document.getElementsByTagName('main')[0];
      const header = document.getElementsByTagName('header')[0];
      const footer = document.getElementsByTagName('footer')[0];
      const footerNav = document.querySelectorAll('.footer-nav')[0];
      main.style.opacity = 0;
      header.style.opacity = 0;
      footer.style.opacity = 0;
      footerNav.style.opacity = 0;
      copyImg[0].style.opacity = 0;
      copyImg[0].style.transition = "1s";
      copyImg[0].style.display = "block";
      copyImg[1].style.opacity = 0;
      copyImg[1].style.transition = "1s";
      copyImg[1].style.display = "block";
      setTimeout(() => {
        footer.style.transition = "1s";
        header.style.transition = "1s";
        main.style.transition = "1s";
        footerNav.style.transition = "1s";
        copyImg[0].style.opacity = 1;
      }, 200);
      setTimeout(() => {
        copyImg[1].style.opacity = 1;
      }, 1400);
      setTimeout(() => {
        copyImg[0].style.opacity = 0;
        copyImg[1].style.opacity = 0;
        copyBack[0].style.display = "none";
      },3000);
      setTimeout(() => {
        this.props.displayChange();
        main.style.opacity = 1;
        header.style.opacity = 1;
        footer.style.opacity = 1;
        footerNav.style.opacity = 1;
      }, 3400)

    }

    fadeinIntoView(){
      const elems = document.getElementsByClassName('fadein');
        for(let i = 0; i < elems.length; i++){
          const rect = elems[i].getBoundingClientRect();
          const scroll = document.documentElement.scrollTop || document.body.scrollTop,
          elemPos = rect.top + scroll,
          windowHeight = window.innerHeight;
          if(scroll > elemPos - windowHeight + 100){
            elems[i].classList.add('scrollin');
          }
        }
    }
    render() {
        const options = {
          columnWidth: '.grid-sizer',
          itemSelector: '.grid-item',
          percentPosition: true
        }
        const title = '映画『コンプリシティ／優しい共犯』公式サイト 2020年1月17日(金)公開';
        const description = '技能実習の職場から逃亡、他人になりすまして働きにきた中国人青年と、彼を受け入れる孤独な蕎麦職人。嘘の上に絆を強める二人を待つものとは？その決断に心震えるヒューマンサスペンス。';

        return (
          <Style>
          <Helmet
              title={title}
              meta={[
                  { property: 'description', content: description },
                  { property: 'keywords', content: 'コンプリシティ, 優しい共犯, COMPLICITY,ルー・ユーライ, 藤竜也, 近浦啓, 赤坂沙世,松本紀保,クロックワークス,クレイテプス,' },
                  { property: 'og:type', content: 'website' },
                  { property: 'og:url', content: window.location.href },
                  { property: 'og:title', content: title },
                  { property: 'og:image', content: 'https://complicity.movie/OGP.png' },
                  { property: 'og:description', content: description },
                  { property: 'og:site_name', content: '映画『コンプリシティ／優しい共犯』公式サイト 2020年1月17日(金)公開' },
                  { name: 'twitter:image', content: 'https://complicity.movie/OGP.png' },
                  { name: 'twitter:card', content: 'summary_large_image' },
                  { name: 'twitter:site', content: '@ComplicityMovie' },
              ]}
              link={[
                { rel: 'canonical', href: window.location.href}
            ]}
            />
            <main onScroll={this.handleScroll}>
                <MainVisual />
                <Break />
                <div className="main-container">
                  <MainContainerL
                      size = { 'L' }
                      pcImg = { 'L_01.jpg' }
                      spImg = { 'L_01_sp.jpg' }
                      link = { 'https://www.tiff.net/events/complicity' }
                      head = { '深い感動をもたらす<br>卓越したデビュー作品だ' }
                      body = { 'Complicity is an accomplished and deeply moving debut for director Kei Chikaura.' }
                      icon = { 'icon01.png' }
                      writer = { 'トロント国際映画祭 プログラマー<br>ジョバンナ・フルヴィ' }
                      textPosition = { "left" }
                      static = { true }
                  />
                  <Masonry className="main-container__inner" options={options} enableResizableChildren>
                      <div className="grid-sizer"></div>
                      <MainContainerM
                        img = { '/2019/11/M_08.jpg' }
                        link = { 'https://www.instagram.com/p/Bt1V6nJnUHG/?utm_source=ig_web_copy_link' }
                        head = { '近浦啓監督「COMPLICITY」ヨーロッパ初上映 <span class="underline">満員御礼！</span>' }
                        body = { 'Full house for the European premiere of COMPLICITY by Kei Chikaura!' }
                        icon = {'/2019/11/icon29.png'}
                        writer = { 'ベルリン国際映画祭' }
                        type = { "insta" }
                      />
                      {this.state.firstList}
                  </Masonry>
                  {this.state.listContainer}
                </div>
                <Billing />
                <TopButton />
            </main>
            <div className="loading">
              <div className="loading-inner"></div>
          </div>
          <div className="loading-copy">
              <img src={MainCopy01} alt="" />
              <img src={MainCopy02} alt="" />
          </div>
          </Style>
        );
    }
}

const Style = styled.div`@charset "UTF-8";body,html{height:100%}.main-visual{position:fixed;bottom:2px;width:100%;height:calc(100vh - 62px);z-index:0}@media (max-width:1024px){.main-visual{height:100vh;bottom:0}}@media (max-width:768px){.main-visual{position:static;height:auto;padding-top:158.66667%;background-image:url(${SpBgImg});background-size:cover;background-position:bottom;background-repeat:no-repeat}}.main-visual__image{position:absolute;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}@media (max-width:768px){.main-visual__image{display:none}}.main-visual__image .main-images{height:calc(100vh - 62px);width:auto}.main-visual__logo{width:100%;position:absolute;bottom:67px;z-index:1;text-align:center}@media (max-width:768px){.main-visual__logo{display:none}}.main-visual__logo:before{position:absolute;content:"";bottom:17%;left:0;height:70%;width:100%;background-color:#fff;z-index:-1}@media (max-width:768px){.main-visual__logo:before{display:none}}.main-visual__logo span{position:relative;display:inline-block}.main-visual__logo span>img{width:84.50704%;max-width:960px}@media (max-width:768px){.main-visual__logo span>img{width:80%}}.main-visual__theater{position:absolute;width:200px;bottom:110%;left:-6%}@media (max-width:768px){.main-visual__theater{position:static;width:80%;margin:0 auto;padding:40px 0}}.main-visual__theater>a{margin-bottom:10px;display:block;-webkit-box-shadow:5px 5px 7px rgba(0,0,0,.3);box-shadow:5px 5px 7px rgba(0,0,0,.3)}@media (max-width:768px){.main-visual__theater>a{margin-bottom:15px}}.main-visual__theater-btn{width:100%;height:40px;background-color:#000;-webkit-box-shadow:5px 5px 7px rgba(0,0,0,.3);box-shadow:5px 5px 7px rgba(0,0,0,.3)}@media (max-width:768px){.main-visual__theater-btn{height:60px}}.main-visual__theater-btn a{color:#fff;font-size:1.2rem;display:block;width:100%;height:100%;line-height:40px;text-align:center;font-weight:700;-webkit-transition:color .2s;transition:color .2s}@media (max-width:768px){.main-visual__theater-btn a{line-height:60px;font-size:1.4rem}}.main-visual__theater-btn a:hover{color:#ff0}.main-visual__roadshow{position:absolute;width:134px;bottom:55%;right:-3%}@media (max-width:768px){.main-visual__roadshow{display:none}}.main-container{position:relative;z-index:1;background-color:#fff;padding-bottom:100px}.main-container__inner{max-width:1200px;margin:0 auto}.main-container__S{width:33.33333%;margin:0 0 90px;padding:0 35px}@media (max-width:1024px){.main-container__S{width:50%}}@media (max-width:768px){.main-container__S{width:80%;left:50%!important;-webkit-transform:translateX(-50%);transform:translateX(-50%);padding:0}}@media (min-width:1024px){.main-container__S:hover .main-container__S-icon>img{opacity:0}.main-container__S:hover .main-container__S-icon-hover{opacity:1;left:20px}.main-container__S:hover .icon-flame{opacity:1}}.main-container__S a{display:block}.main-container__S a h3{font-size:2.4rem;line-height:1.66667;margin-bottom:20px;font-weight:400}@media (max-width:768px){.main-container__S a h3{font-size:2rem;line-height:1.6}}.main-container__S a>p{font-size:1.6rem;line-height:1.75;margin-bottom:20px;font-weight:300}@media (max-width:768px){.main-container__S a>p{font-size:1.4rem;line-height:1.71429}}.main-container__S-img{margin-bottom:30px}.main-container__S-icon{position:relative;font-size:1.4rem;line-height:1.5;padding-left:71px;font-weight:300;margin-top:35px}@media (max-width:768px){.main-container__S-icon{font-size:1.2rem;padding-left:54px}}.main-container__S-icon>img{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);left:0;width:58px;height:58px;z-index:1;opacity:1;-webkit-transition:all .3s;transition:all .3s}@media (max-width:768px){.main-container__S-icon>img{width:40px;height:40px}}.main-container__S-icon-hover{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);left:0;width:16px;height:16px;-webkit-transition:all .5s;transition:all .5s;z-index:2;opacity:0;-webkit-transition:all .3s;transition:all .3s}.main-container__S-label{display:-webkit-box;display:-ms-flexbox;display:flex;margin:0 0 15px}.main-container__S-label li.first{width:48px;margin-right:8px}.main-container__S-label li.second{width:84px}.main-container__M{width:66.66667%;margin:0 0 90px}@media (max-width:1024px){.main-container__M{width:50%}}@media (max-width:768px){.main-container__M{width:80%;left:50%!important;-webkit-transform:translateX(-50%);transform:translateX(-50%)}}@media (min-width:1024px){.main-container__M:hover .main-container__M-icon>img{opacity:0}.main-container__M:hover .main-container__M-icon-hover{opacity:1;left:20px}.main-container__M:hover .icon-flame{opacity:1}}.main-container__M a{display:block}.main-container__M a h3{font-size:3.2rem;line-height:1.5;letter-spacing:.075em;margin-bottom:20px;font-weight:400}@media (max-width:1024px){.main-container__M a h3{font-size:2.4rem;line-height:1.83333}}@media (max-width:768px){.main-container__M a h3{font-size:2rem;line-height:1.6}}.main-container__M-img{margin-bottom:30px}.main-container__M-text{padding:0 35px}@media (max-width:768px){.main-container__M-text{padding:0}}.main-container__M-text>p{font-size:1.8rem;line-height:1.77778;margin-bottom:20px;font-weight:300}@media (max-width:768px){.main-container__M-text>p{font-size:1.4rem;line-height:1.71429}}.main-container__M-icon{position:relative;font-size:1.4rem;line-height:1.5;padding-left:71px;font-weight:300;margin-top:35px}@media (max-width:768px){.main-container__M-icon{font-size:1.2rem;padding-left:54px}}.main-container__M-icon>img{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);left:0;width:58px;height:58px;z-index:1;opacity:1;-webkit-transition:all .3s;transition:all .3s}@media (max-width:768px){.main-container__M-icon>img{width:40px;height:40px}}.main-container__M-icon-hover{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);left:0;width:16px;height:16px;-webkit-transition:all .5s;transition:all .5s;z-index:2;opacity:0;-webkit-transition:all .3s;transition:all .3s}.main-container__M-label{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0 35px;margin:0 0 15px}@media (max-width:768px){.main-container__M-label{padding:0}}.main-container__M-label li.first{width:48px;margin-right:8px}.main-container__M-label li.second{width:84px}.main-container__L{position:relative;width:100%;height:640px;margin-bottom:140px;overflow:hidden;margin-top:80px}@media (max-width:1024px){.main-container__L{height:480px}}@media (max-width:768px){.main-container__L{height:320px;margin-bottom:60px;margin-top:0}}.main-container__L:first-of-type{margin-top:0}.main-container__L>img{position:absolute;top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);z-index:0;height:100%;width:auto}@media (min-width:1366px){.main-container__L>img{width:100%;height:auto}}@media (min-width:1024px){.main-container__L:hover .main-container__L-icon>img{opacity:0}.main-container__L:hover .main-container__L-icon-hover{opacity:1;left:20px}.main-container__L:hover .icon-flame{opacity:1}}.main-container__L:last-of-type{margin-bottom:0}.main-container__L a{display:block;width:100%;height:100%}@media (max-width:1024px){.main-container__L a{padding:0 10%}}@media (max-width:768px){.main-container__L a{padding:0}}.main-container__L a h3{font-size:3.2rem;letter-spacing:.075em;line-height:1.875;color:#fff;margin-bottom:10px;font-weight:400}@media (max-width:1024px){.main-container__L a h3{font-size:2.4rem}}@media (max-width:768px){.main-container__L a h3{font-size:2.4rem;line-height:1.5}}.main-container__L a p{font-size:1.4rem;line-height:1.77778;color:#fff;margin-bottom:20px}@media (max-width:768px){.main-container__L a p{font-size:1.2rem}}.main-container__L-inner{position:relative;max-width:calc(1200px + 10%);height:100%;margin:0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 10%}@media (max-width:1024px){.main-container__L-inner{padding:0 10%}}.main-container__L-inner.left{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.main-container__L-text{position:relative;width:66.66667%;z-index:1}@media (max-width:768px){.main-container__L-text{width:100%}}.main-container__L-icon{position:relative;font-size:1.4rem;line-height:1.5;padding-left:71px;font-weight:300;margin-top:35px;color:#fff}@media (max-width:768px){.main-container__L-icon{font-size:1.2rem;padding-left:54px}}.main-container__L-icon>img{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);left:0;width:58px;height:58px;z-index:1;opacity:1;-webkit-transition:all .3s;transition:all .3s}@media (max-width:768px){.main-container__L-icon>img{width:40px;height:40px}}.main-container__L-icon-hover{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);left:0;width:16px;height:16px;-webkit-transition:all .5s;transition:all .5s;z-index:2;opacity:0;-webkit-transition:all .3s;transition:all .3s}.main-container__L-icon .icon-flame{border-color:#fff}.main-container__L-label{display:-webkit-box;display:-ms-flexbox;display:flex;margin:0 0 15px}.main-container__L-label li.first{width:48px;margin-right:8px}.main-container__L-label li.second{width:84px}.grid-sizer{width:33.33333%}@media (max-width:1024px){.grid-sizer{width:50%}}@media (max-width:768px){.grid-sizer{width:80%}}.sp_only.theater{background-color:#cbccd0}.hover-img{position:absolute;top:0;left:0;z-index:-1}.pc_theater{-webkit-transition:opacity .2s;transition:opacity .2s}.main-visual__theater>a:hover .pc_theater{opacity:0}.break{z-index:-2;position:relative;padding-top:100vh}@media (max-width:768px){.break{padding-top:0}}.comment{position:relative}.quotation{position:absolute}.underline{background:-webkit-gradient(linear,left top,left bottom,color-stop(70%,rgba(255,255,0,0)),color-stop(0,#ff0));background:linear-gradient(rgba(255,255,0,0) 70%,#ff0 0)}.fadein{opacity:0;-webkit-transform:translateY(50px);transform:translateY(50px);-webkit-transition:all 1s;transition:all 1s}@media (max-width:768px){.fadein{-webkit-transform:translate(-50%,50px);transform:translate(-50%,50px)}}.fadein.scrollin{opacity:1;-webkit-transform:translate(0);transform:translate(0)}@media (max-width:768px){.fadein.scrollin{-webkit-transform:translate(-50%);transform:translate(-50%)}}@media (max-width:768px){.main-container__L.fadein.scrollin{-webkit-transform:translate(0);transform:translate(0)}}.icon-flame{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);left:0;content:"";width:58px;height:58px;z-index:1;-webkit-transition:all .3s;transition:all .3s;border:1px solid #4b4b4b;border-radius:100px;opacity:0}.twitter>img{width:14px;vertical-align:sub;margin-left:5px}.facebook img,.filmarks img,.insta img{width:16px;vertical-align:sub;margin-left:5px}body.fixed header{z-index:100}#billing{position:relative;font-weight:600;padding:60px 80px 65px;font-size:11px;letter-spacing:.01em;background-color:#fff;line-height:1.6}#billing dl,#billing ul{display:-webkit-box;display:-ms-flexbox;display:flex;list-style:none;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}.big-char{font-size:24px}.middle-char{font-size:20px}.small-char{font-size:10px}.main-cast li{margin:0 11px 10px}.cast{font-size:16px;margin:0 auto 15px;width:500px}.cast li{margin:0 7px}.slash{position:relative}.slash:before{position:absolute;content:"／";left:-14px}.director{margin-bottom:15px}.director dt{font-size:16px}.theme-song{margin-bottom:10px}.staff dd{margin-right:14px}#billing>:nth-child(6){margin-bottom:18px}.others dd{margin-right:10px}.others>:nth-child(5){margin-right:25px}@media screen and (max-width:834px){#billing{padding:40px 32px;font-size:10px}.main-cast{margin-bottom:5px}.main-cast li{margin:0 10px}.big-char{font-size:16px}.middle-char{font-size:14px}.middle-mini{font-size:12px}.cast{width:100%;max-width:320px;margin:0 auto 10px;font-size:10px}.cast li{width:20%;min-width:62px;margin:0;text-align:center}.slash:before{left:-6px}.director{margin-bottom:10px}.theme-song{margin-bottom:5px;font-size:10px}.theme-song>*{display:inline;text-align:center}.song-name{width:100%}.uni{display:block;text-align:center}.staff{margin-bottom:5px!important}.others{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}@media screen and (max-width:425px){.producer-width{width:196px}}`;;

function Container(props) {
    const currentDate = Math.floor( new Date().getTime() / 1000 );
    const postDate = Math.floor( Date.parse(props.postDate.replace(/-/g, '/')) / 1000 );
    let isNew = false;
    if(604800 > currentDate - postDate){
      isNew = true;
    }
    const data = props.data;
    if(data.size === "S"){
      return  (
        <MainContainerS
            size = { data.size }
            img = { data[data.pcImg] }
            link = { data.link }
            quote = { data.quote }
            head = { data.head }
            body = { data.body }
            icon = { data[data.writerIcon] }
            writer = { data.writer }
            type = { data.SnsType }
            snsIcon = { data[data.SnsIcon] }
            isNew = { isNew }
            isContribute = { data.contributionComments }
          />
      );
    }else if(data.size === "M" && data.isYouTube === "1"){
      return  (
        <MainContainerYT
            size = { data.size }
            img = { data[data.pcImg] }
            link = { data.link }
            quote = { data.quote }
            head = { data.head }
            body = { data.body }
            icon = { data[data.writerIcon] }
            writer = { data.writer }
            YouTubeUrl = { data.YouTubeUrl }
            type = { data.SnsType }
            snsIcon = { data[data.SnsIcon] }
            isNew = { isNew }
            isContribute = { data.contributionComments }
          />
      );
    }else if(data.size === "M"){
      return  (
        <MainContainerM
            size = { data.size }
            img = { data[data.pcImg] }
            link = { data.link }
            quote = { data.quote }
            head = { data.head }
            body = { data.body }
            icon = { data[data.writerIcon] }
            writer = { data.writer }
            isYouTube = { data.isYouTube }
            YoutubeUrl = { data.YoutubeUrl }
            type = { data.SnsType }
            snsIcon = { data[data.SnsIcon] }
            isNew = { isNew }
            isContribute = { data.contributionComments }
          />
      );
    }else if(data.size === "L"){
      return (
        <MainContainerL
              size = { 'L' }
              pcImg = { data[data.pcImg] }
              spImg = { data[data.spImg] }
              link = { data.link }
              quote = { data.quote }
              head = { data.head }
              body = { data.body }
              icon = { data[data.writerIcon] }
              writer = { data.writer }
              static = { false }
              textPosition = {data.textPosition}
              type = { data.SnsType }
              snsIcon = { data[data.SnsIcon] }
              isNew = { isNew }
              isContribute = { data.contributionComments }
        />
      );
    }else{
      return null;
    }
}

export default Home;